import React from 'react'
import { createTheme, ThemeProvider as Provider } from '@mui/material'

const theme = createTheme({
  typography: {
    fontFamily: 'DINRoundPro, sans-serif',
    h1: {
      fontSize: '1.5rem',
      fontWeight: 500,
    },
    h2: {
      fontSize: '1rem',
      fontWeight: 500,
    },
  },
  palette: {
    primary: {
      main: '#A10037',
    },
    secondary: {
      main: '#DB4646',
      light: '#FBECEC',
    },
  },
})

interface ThemeProviderProps {
  children: React.ReactElement<any, string | React.JSXElementConstructor<any>> | null
}

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
  return <Provider theme={theme}>{children}</Provider>
}
